export default {"src":"/blog/_next/static/media/pinterest.4ddaae4a.svg","height":1335,"width":1335};